

















































































































import WidgetMixins from '../../../../mixins/WidgetMixins';
import Component, { mixins } from 'vue-class-component';
import { carriers, loadWidget } from '@/utils/helpers';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { Getter, namespace } from 'vuex-class';
import {
  IDialogAndButtonAction,
  IPaymentDetails,
  IProduct,
  IResolveAccount,
  IUser,
  IUSSDServiceCodes,
  PayloadState,
} from '@/types/types';
const ussdCodeModule = namespace('ussdCodes');
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { numeric, required } from 'vee-validate/dist/rules';
import { ussdCodes } from '@/store/modules/ussd-codes';

extend('required', {
  ...required,
  message: 'Field is required',
});
@Component({
  name: 'CreateUSSDCodeDialog',
  components: {
    ValidationProvider,
    ValidationObserver,
    SkeletonPreloader: loadWidget('widgets/SkeletonPreloader'),
  },
})
export default class CreateUSSDCodeDialog extends mixins(WidgetMixins) {
  @Getter('getResetFormState') resetFormState!: boolean;
  @ussdCodeModule.Getter('getResetFormValues') resetFormValues!: IUSSDServiceCodes;

  @Prop({ default: false, required: true }) state!: boolean;
  @Prop({ default: false }) dialogLoading!: boolean;
  @Prop({ default: false }) loading!: boolean; // button loading
  @Prop({ default: false }) link!: string;

  ussdCode: Pick<IUSSDServiceCodes, 'consumer' | 'description' | 'apiUrl' | 'code'> = {
    consumer: '',
    description: '',
    apiUrl: '',
    code: '',
  };

  @Watch('resetFormState')
  onFormChange(payload: boolean) {
    if (payload) {
      this.ussdCode = { ...this.resetFormValues };
    } else this.$store.dispatch('resetFormValues', false, { root: true });
  }

  @Emit('ussdCode')
  addUSSDServiceCode() {
    return {
      loading: {
        idx: 'add',
        state: false,
      },
      body: {
        ...this.ussdCode,
      },
    };
  }

  @Emit('actions')
  close(): PayloadState {
    return {
      idx: 'add',
      state: false,
    };
  }
}
